import pubsub from 'pubsub-js';
import gaTracker from './ga-tracker'; 
import Cookie from 'js-cookie';
var $modal;


function init() {
     
    $modal = $('#js-survey-modal');
    // Add a delay to modal appearing 
    setTimeout(function() {
        showModal();
    }, 1000);
    

    $modal.on('hidden.bs.modal' , dismissModal); 
    pubsub.subscribe('modal.survey.show', showModal);
    pubsub.subscribe('modal.survey.hide', dismissModal);
    pubsub.subscribe('hidden.bs.modal', dismissModal); // Occurs when the modal is fully hidden (after CSS transitions have completed)
    
}

function showModal(event, data) {
    var survey = loadSurvey() || {name: '', fields: [], appearsOn: ''};
    if (survey.name) { 
        var form = createForm(survey.fields.fields);
        $('.SurveyModal .js-modal-body').append(form[0]);
        // Prevent the default form submission behavior
        // Counter-intuitive to do this inside of the "showModal" 
        $('.SurveyModal form').submit(function(event) {
            event.preventDefault();
            // Sneak in a convention here where the leading option is the "default" option 
            let defaultOption = survey.fields.fields["0"].options[0];
            if (event.target[0].value === defaultOption) { 
                // let value = `Submitted but no response: ${defaultOption}`
                // submitToGTM(value, survey.name);
                // Don't let them submit and don't close the modal until they pick something other than the default option
                var labelText = 'Please select an option';
                var pleaseSelectAnOptionLabel= $('<label>').attr({
                    for: 'selectDropdown'
                 }).text(labelText);
                 pleaseSelectAnOptionLabel.addClass('text-danger');
                $('.SurveyModal .formRow')[0].append(pleaseSelectAnOptionLabel[0])
                return;
            } else {
                submitToGTM(event.target[0].value, survey.name);
                dismissModal(); 
                
            }
            
            
        });
    }
    
    
    try {
        event.preventDefault();
   } catch(error) {

   }
   var $this = $(this);
   var title = (survey && survey.name) ? survey.name : '';

   if (title) {
       $modal.modal('show'); 
   }
   if (!$this.data('ga')) {
    gaTracker.track(`survey|Show survey|${title}`);
}

}

/**
 * @name dismissModal
 * @description - Trigger the hide event and expire the cookie
 */
function dismissModal() {
    $('#js-survey-modal form').remove();
    var THANK_YOU_MESSAGE = 'Thanks!';
    var thankYou = $('<h3>').text(THANK_YOU_MESSAGE); 
    $('.SurveyModal .js-modal-body').append(thankYou);
    setTimeout(function() {
        $('#js-survey-modal').modal('hide');
    },1000)
    dismissSurvey();
}


/**
 * @name dismissSurvey 
 * @description - Regardless of whether of not they've answered, go ahead and remove the cookies
 */

 function dismissSurvey() {
    // Regardless of whether or not they answered, expire the cookie
    Cookie.remove('hasSurvey')
    Cookie.set('hasSurvey', -1);
    Cookie.set('hasTakenSurvey', 1); // The optimizely code sets the cookie again, so let's set our own to indicate they've taken the survey.
 }


function loadSurvey() {
    try {
        var survey = window.localStorage.survey;
        survey = JSON.parse(survey);
        } catch(error) {
    }
    return survey;

    
}

/**
 * @name createForm
 * @param {array} fields - Array of objects of form fields 
 * @description - Take in an array of fields and create HTML form elements and append them to a form
 * @return {HTML} form 
 */
// This doesn't make sense anymore. 
// I should not be setting a title inside of a map function, but I tied the form label to the form field...
function createForm(fields) {
    var form = $('<form>');
    $(form).addClass('form-inline');
    fields.map(function(field) {
        switch(field.type) {
            case('select'): 
                var selectField = $('<select>').attr({
                    name: 'selectDropdown'
                });
                $(selectField[0]).on("change", function(event) {
                    // Once they've made a change activate the button and remove the danger text if there
                    $('#submitSurvey').removeClass('disabled');
                    $('#js-survey-modal .text-danger').remove();
                })
                
                $('.js-modal-title').text(field.label);
                var formRow = $('<p>').addClass('formRow');
                
                field.options.map(function(option) {
                    
                    var option = $('<option>').attr({
                        name: option,
                        value: option
                    }).text(option);
                    
                    selectField[0].append(option[0]);
                });
                formRow = $('<p>').addClass('formRow');
                formRow[0].append(selectField[0]);
                $(form)[0].append(formRow[0]);
            default: 
                field.option = $('<input>').attr({
                    type:"text",
                    placeholder: 'Input field'
                });
        }
    });
    var submitButton = $('<button>').attr({
        id: 'submitSurvey',
    }).text('Submit');
    submitButton.addClass('btn');
    submitButton.addClass('btn-primary');
    submitButton.addClass('disabled');
    
    $(form)[0].append(submitButton[0]);

    return form;

}

function submitToGTM(value, name) {
    gaTracker.track(`survey|${name}|${value}`);
}

export default init;





// var fields = {
//     'formName': 'Carrier Survey',
//     'fields': [],
//   }; 
  
//   var selectFormField  = {
//     name: 'carrier-option', 
//     type: 'select',
//     label: 'Who is your current wireless provider?',
//     options: ['Device Carrier','AT&T', 'Mint', 'Sprint', 'T-Mobile', 'Verizon', 'Other'] 
//   };
  